import React from "react";
import {SubscriptionRule} from "fearless-common";

/**
 * Get a nice explanatory text for the subscription 'via', i.e. the way the subscription
 * is established, e.g. individually, via a group or via a rule.
 */
export default function getViaRuleText(rule: SubscriptionRule) {
  if (rule.institute_id && rule.type === 'email_domain') {
    return <>via email domain <i>@{rule.value}</i></>
  } else if (rule.type === 'email_domain') {
    return <>via email domain <i>@{rule.value}</i></>
  }
  return 'automatically via rule';
}
